import { buildChineseWebsiteSteps } from '@/base/buildPlatformConfig'
const stepStore = {
  state: {
    currentStep: -1,
    stepsData: buildChineseWebsiteSteps
  },
  mutations: {
    setCurStep: (state, status) => {
      state.currentStep = status
    },
  },
  actions: {
  }
}

export default stepStore
